import axios, { isAxiosError } from 'axios';
import { BASE_URL } from '../../apis/utils/provider';
import { getCoreAuthHeader } from '../../utils/getCoreAuthHeader';
import { store } from '../../store';
import { shouldUseCoreApi } from '../../utils/features';
import { getItem, setItem } from '../../utils/storage';
import { refreshUser } from '../Login/LoginSlice/actionCreators';
import { setIsOnline } from './checkAppAvailableSlice';
import { API_VERSION } from '../../config/app';

const CORE_BASE_URL = process.env.REACT_APP_CORE_API_BASE_URL;

const sendCheckRequestOrThrow = async (): Promise<void> => {
  const promises = [
    axios.request({
      baseURL: BASE_URL,
      method: 'GET',
      url: `/account/authstatus`,
      withCredentials: true,
      responseType: 'json',
      headers: {
        ...getCoreAuthHeader(),
        'X-XSRF-Token': getItem('csrf'),
      },
    }),
    ...(shouldUseCoreApi()
      ? [
          axios.request({
            baseURL: CORE_BASE_URL,
            method: 'GET',
            url: '/core/v1/tenants',
            headers: {
              authorization: `Bearer ${getItem('coreApiAccessToken')}`,
              'cosafe-api-version': String(API_VERSION),
            },
          }),
        ]
      : []),
  ];

  await Promise.all(promises);
};

const addRandomTimeoutAndSave = (callback: () => void) => {
  const delayTimesArray = [0, 1000, 2000, 3000, 4000, 5000, 6000];
  const randomDelayTimeIndex = Math.floor(Math.random() * delayTimesArray.length);
  const delayTime = delayTimesArray[randomDelayTimeIndex];
  const recheckTimeout = setTimeout(callback, delayTime);
  setItem('recheckTimeOut', recheckTimeout);
};

export const checkNetworkAvailability = async ({
  checkIfNetworkBack,
}: {
  checkIfNetworkBack?: boolean;
} = {}) => {
  try {
    await sendCheckRequestOrThrow();
    addRandomTimeoutAndSave(() => {
      store.dispatch(setIsOnline(true));
      store.dispatch(refreshUser(true));
    });
  } catch (error) {
    if (!isAxiosError(error)) {
      return;
    }

    if (error.response && error.response.status !== 401 && !checkIfNetworkBack) {
      store.dispatch(setIsOnline(false));
    }

    if (error.response?.status === 401) {
      addRandomTimeoutAndSave(() => {
        store.dispatch(setIsOnline(true));
      });
    }

    if (!error.response && error.request) {
      // The client never received a response, and the request was never left
      if (!checkIfNetworkBack) {
        store.dispatch(setIsOnline(false));
      }
    }
  }
};
